import IntegrationAccountSelect from './IntegrationAccountSelect';

export default IntegrationAccountSelect;
